import { put, call, CallEffect, PutEffect, select } from 'redux-saga/effects';
import { AxiosResponse } from 'axios';
import { Action } from 'redux-saga';
import { setCustomer } from '@/redux/ducks/customer';
import { automaticApi } from '@/settings/api';
import { ReducersTypes } from '@/redux/reducers/Models';
import { Vehicle } from '@/pages/auth/vehicles/Models';
import { mergeVehicleLists } from './utils';

export interface Fetch {
    callback?: (success: boolean) => void;
}

export interface GetVehiclesAction {
    type: string;
    payload: Fetch;
}

const uri = '/home-app/v1/init/userproduct';
const USER_PRODUCT_PAGE_SIZE = 15;

const getCustomer = (state: ReducersTypes) => state.customerReducer;

export default function* getVehicles({
    payload,
}: GetVehiclesAction): Generator<
    CallEffect<unknown> | PutEffect<Action>,
    void,
    AxiosResponse
> {
    try {
        yield put(setCustomer({ isLoadingVehicles: true }));

        let fromPage = 1;
        let totalPages = 1;
        let allListVehicle: Vehicle[] = [];
        let allListGarageVehicle: Vehicle[] = [];
        let products: unknown;

        do {
            const response = yield call(automaticApi.get, `${uri}?offset=${USER_PRODUCT_PAGE_SIZE}&fromPage=${fromPage}`);

            if (response?.data?.contractedProductPagination?.totalPages) {
                totalPages = response.data.contractedProductPagination.totalPages;
            }

            if (Array.isArray(response?.data?.listVehicle)) {
                allListVehicle = [...allListVehicle, ...response.data.listVehicle];
            }
            if (Array.isArray(response?.data?.listGarageVehicle)) {
                allListGarageVehicle = [...allListGarageVehicle, ...response.data.listGarageVehicle];
            }
            if (response?.data?.products) {
                products = response.data.products;
            }

            fromPage++;
        } while (fromPage <= totalPages);

        const vehicles = mergeVehicleLists(allListVehicle, allListGarageVehicle);

        // @ts-expect-error
        const customer: ReducersTypes['customerReducer'] = yield select(getCustomer);
        const shouldInitializeSelectedVehicles = (vehicles?.length ?? 0) > 0 &&
          (!customer?.selectedVehicles || customer.selectedVehicles.length === 0);

        yield put(
            setCustomer({
                isLoadingVehicles: false,
                products,
                vehicles,
                ...(shouldInitializeSelectedVehicles && vehicles?.[0]?.plate && { selectedVehicles: [vehicles[0].plate] })
            })
        );
        if (payload?.callback) yield call(payload.callback, true);
    } catch (error) {
        yield put(setCustomer({ isLoadingVehicles: false }));
        if (payload?.callback) yield call(payload.callback, false);
    }
}